import { render, staticRenderFns } from "./EditTag.vue?vue&type=template&id=16e58564"
import script from "./EditTag.vue?vue&type=script&lang=js"
export * from "./EditTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports